import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import env from '@/env';
import { AuditQuestion } from '../types';

export const getAuditorQuestionssForMe = async ({
  page,
  pageSize,
  search,
  sortBy,
  dateFrom,
  dateTo,
}: BrowseViewState & { dateFrom: string; dateTo: string }): Promise<
  BrowseViewResponseDto<AuditQuestion>
> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-questions/me?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: sortBy ? JSON.stringify(sortBy) : '',
      dateFrom: dateFrom ?? '',
      dateTo: dateTo ?? '',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<AuditQuestion>;
  return response;
};
